'use client';

import React, { useCallback, useMemo } from 'react';
import {
  AsyncComponent,
  ConfiguredComponents,
} from '@r-and-a-shared-ui/core-component-config';
import { ppTrpc } from '@r-and-a-shared-ui/randa-trpc-client/react';
import { hasValue } from '@r-and-a-shared-ui/utils';

export const PageRender = (props: any) => {
  const { pageCodeName, templateName } = props.pageResponse || props;

  const shouldFetchTemplate = useMemo(() => {
    return hasValue(templateName);
  }, [templateName]);

  const { data: fullPage } = ppTrpc.kontent.pageByCodename.useQuery(
    { codename: pageCodeName },
    {
      enabled: hasValue(pageCodeName),
    },
  );

  const { data: template } = ppTrpc.kontent.pageTemplateByCodeName.useQuery(
    { codename: templateName },
    {
      enabled: shouldFetchTemplate,
    },
  );

  const renderPage = useCallback(() => {
    if (!fullPage?.page) {
      return null;
    }

    return (
      <AsyncComponent
        key={`page-${fullPage?.page?.system?.id}`}
        kontentItem={fullPage.page}
        contentType={fullPage.page?.system?.type as ConfiguredComponents}
      />
    );
  }, [fullPage]);

  if (!shouldFetchTemplate) {
    return <>{renderPage()}</>;
  }

  return (
    <>
      {template && (
        <>
          <AsyncComponent
            key={`template-${template?.system?.id}`}
            kontentItem={template}
            contentType={template.system.type as ConfiguredComponents}
          >
            {renderPage()}
          </AsyncComponent>
          {/* <GoogleAnalytics gaId="" /> */}
        </>
      )}
    </>
  );
};
